export function accountAttendees() {
    const pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    const accordion = $(".orders-accordion");
    let valid_fields = true;

    function field_validadte($field) {
        let $parent = $field.closest('.form-row'),
            validated = true;

        if ($field.val() !== '' && !pattern.test($field.val())) {
            $parent.addClass('woocommerce-invalid');
            validated = valid_fields = false;
        }

        if (validated) {
            $parent.removeClass('woocommerce-invalid');
        }

        return validated;
    }

    function save_attendees() {
        let forms = $('form.save-attendees');
        if (forms.length) {
            forms.each(function () {
                let cur_form = $(this);

                cur_form.on('input', '.input-text', function () {
                    let $this = $(this);
                    field_validadte($this);
                });

                cur_form.submit(function (e) {
                    e.preventDefault();

                    let $response = cur_form.find('.response'),
                        $submit = cur_form.find('.button');

                    $submit.addClass('isDisabled').attr("disabled", true);

                    valid_fields = true;

                    cur_form.find('.input-text').each(function () {
                        let $this = $(this);
                        field_validadte($this);
                    });

                    if (!valid_fields) {
                        $response.html('Invalid email fields.');
                        $submit.removeClass('isDisabled').attr("disabled", false);

                    } else {
                        let data = {
                            'action': 'save_attendees',
                            'order_id': cur_form.attr('data-order-id'),
                            'data': cur_form.serializeArray()
                        };

                        $.ajax({
                            url: ajax_params.ajaxurl,
                            data: data,
                            type: 'POST',
                            beforeSend: function () {
                                $response.html('');
                            },
                            success: function (res) {
                                $submit.removeClass('isDisabled').attr("disabled", false);

                                if (res.status === true) {
                                    $response.removeClass('error').html(res.message);
                                    setTimeout(function () {
                                        $response.addClass('error').html('');
                                    }, 3000);
                                } else {
                                    $response.addClass('error').html(res.message);
                                }
                            }
                        });
                    }

                    return false;
                });
            });
        }
    }

    save_attendees();

    let form_get_attendees = $('form.get-attendees-by-order');
    if (form_get_attendees.length) {
        let $submit = form_get_attendees.find('.button');

        form_get_attendees.on('input', '.input-text', function () {
            let $this = $(this);

            if ($this.val() !== '') {
                $submit.removeClass('isDisabled').attr("disabled", false);
            } else {
                $submit.addClass('isDisabled').attr("disabled", true);
            }
        });

        form_get_attendees.submit(function (e) {
            e.preventDefault();

            let order_id = form_get_attendees.find('.input-text').val();

            if ($('#order_' + order_id).length) {
                $('.response-attendees').html('');
                $('#order_' + order_id).find('.heading').trigger('click');
                $("html, body").animate({scrollTop: $('#order_' + order_id).offset().top - $('.header').innerHeight() - 20}, 500);

            } else {
                accordion.find(".order-item").removeClass("opened").find(".hidden-info").slideUp();
                $submit.addClass('isDisabled').attr("disabled", true);

                let data = {
                    'action': 'get_attendees',
                    'order_id': order_id
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                    },
                    success: function (res) {
                        $('.response-attendees').html(res);
                        save_attendees();

                        $submit.removeClass('isDisabled').attr("disabled", false);
                    }
                });
            }

            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/account-attendees.js